import React from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import ResetCredentials from 'views/ResetCredentials';
import SignIn from 'views/SignIn/index';
import SignUp from 'views/SignUp/index';

const AuthRoutes: React.FC = () => {
  const { isAuthenticated, doesAccountExist } = useAuth();
  const { pathname } = useLocation();

  if (pathname === '/reset') {
    // skip other validation and continue
  } else if (isAuthenticated && doesAccountExist) {
    return <Redirect to="/links" />;
  } else if (pathname !== '/signup' && isAuthenticated && !doesAccountExist) {
    return <Redirect to="/signup" />;
  }

  return (
    <Switch>
      <Route path={`/reset`} component={ResetCredentials} />
      <Route path="/signin" component={SignIn} />
      <Route path="/signup" component={SignUp} />
      <Redirect exact from="/" to="/signup" />
    </Switch>
  );
};

export default AuthRoutes;
